import React, { Component } from 'react';

import { connect } from 'react-redux';

import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';

import * as ApplicationMessageActions from '../actions/applicationMessageActions';

import classes from './Banner.module.css';

class Banner extends Component {
    state = {
        companyId: '',
        isOpen:    true,
        message:   '',
        class:     ''
    };

    componentDidMount() {
        this.setState({
            companyId: this.props.companyInfo.companyId
        });
        this.handleStatus();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.companyId !== this.props.companyInfo.companyId) {
            this.setState({
                companyId: this.props.companyInfo.companyId
            });
            this.handleStatus();
        }
    }

    handleStatus = () => {
        const { companyInfo } = this.props;

        switch (companyInfo.billingStatus) {
            case 1:
                this.setState({
                    message: 'Your account Payment Status is currently On-Hold. Once you rectify your Payment Status your access to BOB will be re-enabled.',
                    class:   'esms-red-background'
                });
                break;
            case 3:
                this.setState({
                    message: 'Your bill is overdue. Please pay your bill before access to this BOB Company is revoked.',
                    class:   'esms-yellow-background'
                });
                break;
            default:
                break;
        }
    };

    handleClose = () => {
        this.setState({ isOpen: false });

        setTimeout(() => {
            this.setState({ isOpen: true });
        }, 1000);
    }

    render() {
        let { isOpen } = this.state;
        return (
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                className={`${classes.Snackbar}`}
                open={isOpen}
                transitionDuration={1000}
            >
                <SnackbarContent
                    className={this.state.class}
                    message={
                        <span id="banner">
                            {this.state.message}
                        </span>
                    }
                />
            </Snackbar>
        );
    }
}

const mapDispatchToProps = {
    ...ApplicationMessageActions
};

export default connect(null, mapDispatchToProps)(Banner);
